import { CommonModule } from '@angular/common';
import { MultilineFileUploadModule } from 'Angular/features/components/file-upload/multiline-file-upload/multiline-file-upload.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class LPLActivateModalModule {
}
LPLActivateModalModule.ɵfac = function LPLActivateModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LPLActivateModalModule)(); };
LPLActivateModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LPLActivateModalModule });
LPLActivateModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, LoadingSymbolModule, ModalBaseModule, MultilineFileUploadModule] });
